import RouteView from '@/layouts/RouteView'
import store from '../store'
/**
 * 后台查询的菜单数据拼装成路由格式的数据
 * @param routes
 */
export function generaMenu (routes, data) {
  data.forEach(item => {
    const menu = {
      path: (item.actionUri === undefined || item.actionUri === '')
        ? ('/' + (item.resourceId.toString() + Math.ceil(Math.random() * 100).toString())) : item.actionUri,
      component: !item.actionUri ? RouteView : () => import(`@/pages${item.actionUri}`),
      invisible: !item.display,
      // children: [],
      name: item.resourceName,
      icon: item.iconCls,
      meta: {
        isSystem: false
      }
    }
    if (item.children) {
      menu.children = []
      generaMenu(menu.children, item.children)
    }
    routes.push(menu)
  })
}

/**
 * // 处理按钮跳转二级页面
 * @param routes
 * @param data
 */
export function buildInvisiblePageRouter (routes, permissions, keyPathMap) {
  permissions.currentLoginDepartment.departmentSystemAuths.map(n => {
    if (n.authResourceKeys !== undefined) {
      let actionUrls = n.authResourceKeys.filter(item => item.actionUri)
      if (actionUrls.length > 0) {
        routes.filter(item => item.meta !== undefined).map(m => {
          if (n.authKey === m.meta.authKey) {
            actionUrls.forEach(item => {
              const menu = {
                path: item.actionUri,
                component: () => import(`@/pages${item.actionUri}`),
                invisible: true,
                name: item.resourceKey
              }
              keyPathMap.set(item.resourceKey, item.actionUri)
              m.children = m.children.concat(menu)
            })
          }
        })
      }
    }
  })
}

/**
 * // 获取二级页面path
 * @param routes
 * @param data
 */
export function getInvisiblePagePath (resourceKey) {
  const keyPathMap = store.state.user.keyPathMap
  return keyPathMap.get(resourceKey)
}



// WEBPACK FOOTER //
// ./src/utils/handlerMenu.js